import React, { Component } from "react";

import Menu from "./menu";

import LogoSVG from "./images/visual-electric/logo.svg";
import blocksJPG from "./images/flexhouse/blocks.jpg";
import nest1MP4 from "./images/flexhouse/nest1.mp4";
import nest1JPG from "./images/flexhouse/nest1.jpg";
import nest2MP4 from "./images/flexhouse/nest2.mp4";
import nest2JPG from "./images/flexhouse/nest2.jpg";

import artDirectorMP4 from "./images/visual-electric/features/art-director.mp4";
import chatMP4 from "./images/visual-electric/features/chat.mp4";
import filtersMP4 from "./images/visual-electric/features/filters.mp4";
import projectsMP4 from "./images/visual-electric/features/projects.mp4";
import upscaleMP4 from "./images/visual-electric/features/upscale.mp4";
import video1MP4 from "./images/visual-electric/features/video-1.mp4";
import video2MP4 from "./images/visual-electric/features/video-2.mp4";
import workflow2MP4 from "./images/visual-electric/features/workflow.mp4";

import referencesJPG from "./images/visual-electric/features/references.jpeg";

import slide1JPG from "./images/visual-electric/hero/1.png";
import slide2JPG from "./images/visual-electric/hero/2.png";
import slide3JPG from "./images/visual-electric/hero/3.png";
import slide4JPG from "./images/visual-electric/hero/4.png";
import slide5JPG from "./images/visual-electric/hero/5.png";

import "./css/visual-electric.css";

class VisualElectric extends Component {
  render() {
    return (
      <div className="visual-electric-page">
        <Menu type="projects" />
        <div className="intro section-wrapper">
          <div className="slideshow">
            <img src={slide1JPG} alt="" className="slide" style={{ "--i": 0 }} />
            <img src={slide2JPG} alt="" className="slide" style={{ "--i": 1 }} />
            <img src={slide3JPG} alt="" className="slide" style={{ "--i": 2 }} />
            <img src={slide4JPG} alt="" className="slide" style={{ "--i": 3 }} />
            <img src={slide5JPG} alt="" className="slide" style={{ "--i": 4 }} />
          </div>
          <div className="credits">
            Vibrant wildflowers, red poppies, white cosmos, yellow daisies, sway before a pale blue wall in soft
            daylight, gentle tilt infuses motion and a bright, cheerful energy into the image
          </div>
          <div className="section">
            <div className="content">
              <img src={LogoSVG} className="logo" alt="Visual Electric" />
            </div>
          </div>
        </div>

        <div className="section-wrapper">
          <div className="section context">
            <div className="column">
              <h1>
                We're not here to automate creativity.
                <br />
                We're here to bring more of it to life.
              </h1>
              <h2>Opportunity</h2>
              <p>
                Visual Electric is building the first professional grade AI design tool. Our product enables designers
                to bring their vision to life in seconds. We are creative technologists, engineers, designers, and
                machine learning experts backed by some of the best investors in the world. Our mission is to build a
                camera for the mind.
              </p>
              <h2>Introduction</h2>
              <p>
                After going through a multi-year residential project,{" "}
                <a href="https://benbarry.com/" target="_blank" rel="noopener noreferrer">
                  Ben Barry
                </a>{" "}
                saw big opportunities to improve the experience for both homeowners and builders. Together with{" "}
                <a href="https://www.gndclouds.earth" target="_blank" rel="noopener noreferrer">
                  Will Felker
                </a>
                , we began working on{" "}
                <a href="https://flex.house" target="_blank" rel="noopener noreferrer">
                  Flexhouse
                </a>{" "}
                early summer of 2024. I joined as a co-founder and my role was to lead the engineering efforts.
              </p>
              <p>
                Rather than trying to design the perfect system upfront for something as complex as a home, we decided
                to build a series of prototypes, each increasing in complexity, learning as we went.
              </p>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>The new creative workflow</h2>
              <p>
                When I joined, VE was a mature but very opinionated product that attempted to hide away all technical
                complexity from the user. This made it very accessible to new users but it was too limiting for AI
                native creatives that understood the new medium. I helped ship thirteen new product features as well as
                redesigned the core queing service that makes the service tick. Some of which I describe below:
              </p>
            </div>
          </div>
          <div className="video-grid">
            <div className="video-scroller">
              <div className="video-scroller-page">
                <div className="image-wrapper video">
                  <video autoPlay loop muted playsInline preload="auto">
                    <source src={filtersMP4} type="video/mp4" poster={blocksJPG} />
                    Your browser doesn't support HTML5 video tag.
                  </video>
                </div>
                <div className="caption">
                  <h3>Image adjustments</h3>
                  <p>
                    All the adjustments you'd expect for basic photo manipulation. Involved writing custom shaders,
                    caching and compositing on export.
                  </p>
                </div>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={artDirectorMP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={chatMP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={upscaleMP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={video1MP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={video2MP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={workflow2MP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <video autoPlay loop muted playsInline preload="auto">
                  <source src={projectsMP4} type="video/mp4" poster={blocksJPG} />
                  Your browser doesn't support HTML5 video tag.
                </video>
              </div>
              <div className="image-wrapper video">
                <img alt="" src={referencesJPG} />
              </div>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Turning storyboards into video</h2>
              <h2>Making video as light as an image</h2>
              <p>
                Since birdhouses share the same basic structural elements as human houses, we planned to reuse the
                modeling tool, data model, and undo engine in the next prototype. In hindsight, that was a mistake. We
                ended up stuck on birdhouses for most of the summer, which we were okay with, but it became a challenge
                when trying to explain to others what we were working toward.
              </p>
              <h3>Walls</h3>
              <p>
                The structure data model is a{" "}
                <a href="https://en.wikipedia.org/wiki/Planar_graph" target="_blank" rel="noopener noreferrer">
                  planar graph
                </a>{" "}
                of grid-snapped vertices, with regions{" "}
                <a
                  href="https://sci.bban.top/pdf/10.1016/0167-8655%252893%252990104-l.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  automatically detected
                </a>{" "}
                as rooms. Crossing wall segments are split, and I’ve added range boolean operations like delete and
                union. The goal was to enable quickly sketching out a structure, and I’m really happy with how it turned
                out.
              </p>
            </div>
            <div className="image-wrapper video">
              <video autoPlay loop muted playsInline preload="auto">
                <source src={nest1MP4} type="video/mp4" poster={nest1JPG} />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
            <div className="column">
              <h3>Roofs and Fixtures</h3>
              <p>
                These tools were easier to implement than the wall tool, but each still posed challenges. Math, so much
                math.
              </p>
            </div>
            <div className="image-wrapper video">
              <video autoPlay loop muted playsInline preload="auto">
                <source src={nest2MP4} type="video/mp4" poster={nest2JPG} />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>

        <div className="section-wrapper has-divider conclusion">
          <div className="section">
            <div className="column">
              <h2>Looking ahead</h2>
              <p>
                This was my favorite type of work—the kind that pushes me just outside my comfort zone, both technically
                and creatively. I had a great time, and I’m really grateful to Ben and Will for the experience. While
                things didn’t work out (maybe it was too ambitious to try raising funds in 2024 without an AI play), we
                still firmly believe that the future of residential design lies in standardized systems of building and
                accessible tools that make play possible.
              </p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VisualElectric;



// WEBPACK FOOTER //
// ./src/visual-electric.js